/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

import {
     DatabaseBannerHeaderBlockFromJSONTyped,
     DatabaseHeaderBlockFromJSONTyped,
     DatabaseCustomerLogoHeaderBlockFromJSONTyped,
     DatabaseDbMenuHeaderBlockFromJSONTyped,
     DatabaseDescriptionHeaderBlockFromJSONTyped,
     DatabaseEingabelisteHeaderBlockFromJSONTyped,
     DatabaseFinePrintHeaderBlockFromJSONTyped,
     DatabaseImageHeaderBlockFromJSONTyped,
     DatabaseNameHeaderBlockFromJSONTyped,
     DatabaseSubDbListHeaderBlockFromJSONTyped,
     DatabaseTeaserImageHeaderBlockFromJSONTyped,
     DatabaseTextHeaderBlockFromJSONTyped,
     DatabaseTimestampHeaderBlockFromJSONTyped,
     DatabaseTitleHeaderBlockFromJSONTyped,
     DatabaseVideoHeaderBlockFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface DatabaseHeaderBlock
 */
export interface DatabaseHeaderBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    blockType?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    inlineStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    backgroundColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseHeaderBlock
     */
    backgroundOpacity?: number;
    /**
     * 
     * @type {DatabaseHeaderBlockActionType}
     * @memberof DatabaseHeaderBlock
     */
    action?: DatabaseHeaderBlockActionType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    actionContent?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderBlock
     */
    link?: string;
    /**
     * ANZEIGEFILTER DES BLOCKS (Betreiber 03.09.2026: "JA, bitte fuer Header und Footer einbauen"). Gleiche Bauart wie der Anzeigefilter eines Datenfeldes oder einer Feldgruppe: mehrere Zeilen sind ein UND, mehrere Werte in EINER Zeile sind ein ODER.
     * KOPF UND FUSS TEILEN SICH DIESES SCHEMA -- `DatabaseHeaderProperties` steht in `appearance` unter `header` UND unter `footer`. Ein Eintrag hier gilt also fuer beide Bereiche.
     * WOGEGEN GEPRUEFT WIRD: gegen den GEOEFFNETEN Datensatz. Wo keiner offen ist (die Uebersicht), kann eine Bedingung ueber einen Feldwert nicht erfuellt sein -- der Block bleibt dort aus. Bloecke OHNE Regeln sind davon unberuehrt und erscheinen wie bisher ueberall.
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseHeaderBlock
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
}

/**
 * Check if a given object implements the DatabaseHeaderBlock interface.
 */
export function instanceOfDatabaseHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseHeaderBlockFromJSON(json: any): DatabaseHeaderBlock {
    return DatabaseHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['blockType'] === 'BANNER') {
            return DatabaseBannerHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'BASE') {
            return DatabaseHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'CUSTOMER_LOGO') {
            return DatabaseCustomerLogoHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_MENU') {
            return DatabaseDbMenuHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DESCRIPTION') {
            return DatabaseDescriptionHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'EINGABELISTE') {
            return DatabaseEingabelisteHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'FINE_PRINT') {
            return DatabaseFinePrintHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'IMAGE') {
            return DatabaseImageHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'NAME') {
            return DatabaseNameHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'SUB_DB_LIST') {
            return DatabaseSubDbListHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TEASER_IMAGE') {
            return DatabaseTeaserImageHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TEXT') {
            return DatabaseTextHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TIMESTAMP') {
            return DatabaseTimestampHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TITLE') {
            return DatabaseTitleHeaderBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'VIDEO') {
            return DatabaseVideoHeaderBlockFromJSONTyped(json, true);
        }
    }
    return {
        
        'blockType': !exists(json, 'blockType') ? undefined : json['blockType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'backgroundOpacity': !exists(json, 'backgroundOpacity') ? undefined : json['backgroundOpacity'],
        'action': !exists(json, 'action') ? undefined : DatabaseHeaderBlockActionTypeFromJSON(json['action']),
        'actionContent': !exists(json, 'actionContent') ? undefined : json['actionContent'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
    };
}

export function DatabaseHeaderBlockToJSON(value?: DatabaseHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blockType': value.blockType,
        'id': value.id,
        'name': value.name,
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'backgroundOpacity': value.backgroundOpacity,
        'action': DatabaseHeaderBlockActionTypeToJSON(value.action),
        'actionContent': value.actionContent,
        'link': value.link,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
    };
}

